import { competitionCardStyle } from '@bingads-webui-campaign-react/common-styles';
import {
  getPerformanceCardFluentV2Style,
  getPerformanceGraphStyle,
  getTopLocationCardFluentV2Style,
  metricPickerFluentV2Style,
} from '@bingads-webui-campaign-react/overview-card-styles';

export const getDefaultStyles = (_, { palette = {} }) => ({
  '@global': Object.assign(
    metricPickerFluentV2Style,
    getPerformanceCardFluentV2Style(palette),
    getPerformanceGraphStyle(palette),
    getTopLocationCardFluentV2Style(palette),
    competitionCardStyle
  ),
});
